import { PageController } from '@client/components/_core/layout/PageController';
import { ComplianceAuditTemplateAdd } from '@client/components/compliance-audit-templates/ComplianceAuditTemplateAdd';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/platform-content/compliance-audit-templates/search/add')({
    staticData: {
        presentation: 'overlay',
        metadata: { title: 'New file audit template' },
    },
    component: AddTemplateRoute,
});

function AddTemplateRoute() {
    return (
        <PageController route={Route}>
            <ComplianceAuditTemplateAdd />
        </PageController>
    );
}
